import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Radius, Select, Spacing } from 'zens-storybook'

import { WorkspaceSelect } from '../workspace'

import { GraphBar } from './graphbarselect'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: Color.backgroundGrey,
    borderRadius: Radius.S,
    padding: Spacing.M,
    zIndex: 100,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  select: {
    flex: undefined,
  },
  skeletonInput: {
    minWidth: 200,
  },
})

interface Props extends ViewProps {
  companyId: number
  buildingId?: number
  floorId?: number
  workspaceId?: number
  onChangeWorkspaceId?: (workspaceId: number) => void
  bars?: GraphBar[]
  onChangeBars?: (bars?: GraphBar[]) => void
}

const InsightsTimeFilter = (props: Props) => {
  const {
    companyId,
    buildingId,
    floorId,
    workspaceId,
    onChangeWorkspaceId,
    // bars,
    // onChangeBars,
    style,
    ...otherProps
  } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <WorkspaceSelect
        companyId={companyId}
        buildingId={buildingId}
        floorId={floorId}
        style={styles.select}
        value={workspaceId}
        onChange={onChangeWorkspaceId}
      />
      {/* <GraphBarSelect value={bars} onChange={onChangeBars} /> */}
    </View>
  )
}

InsightsTimeFilter.Skeleton = () => {
  return (
    <View style={styles.container}>
      <Select.Skeleton style={[styles.select, styles.skeletonInput]} />
    </View>
  )
}

export default InsightsTimeFilter
